import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.error.cause.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "card"
};
const _hoisted_2 = {
  class: "toolbox"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("匹配");

const _hoisted_4 = {
  class: "card"
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin-bottom": "10px"
  }
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "营业执照/门脸照:", -1);

const _hoisted_7 = {
  class: "dialog-footer"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("关闭");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("驳回");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("通过");

import { get } from 'lodash-es';
import { computed, ref, watch } from 'vue';
import { getApplySimilarCust, matchApplySimilarCust } from '@/request';
import { ElMessage } from 'element-plus';
import { addressRecognition } from '@/request';
export default {
  name: 'AuditAurveyInfoModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    currentData: {
      type: [Object, null],
      default: null
    },
    custTypeList: {
      type: Array,
      default: () => []
    },
    areaTreeData: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const form = ref({
      custName: '',
      linkMan: '',
      linkPhone: '',
      custType: '',
      custAddressCode: '',
      address: ''
    });
    const formRef = ref();
    watch(() => props.modelValue, newVal => {
      var _formRef$value;

      if (!newVal) {
        // 清除效验信息
        form.value = {
          custName: '',
          linkMan: '',
          linkPhone: '',
          custType: '',
          custAddressCode: '',
          address: ''
        };
      }

      (_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.resetFields();
    });
    watch(() => props.currentData, (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        form.value = _objectSpread(_objectSpread({}, newVal), {}, {
          custAddressCode: newVal.custAreaCode || newVal.custCityCode || newVal.custProvinceCode
        });
        getList();
      } else if (!newVal) {
        form.value = {
          custName: '',
          linkMan: '',
          linkPhone: '',
          custType: '',
          custAddressCode: '',
          address: ''
        };
      }
    });

    function changeArea(e) {
      let parent = e;
      form.value = _objectSpread(_objectSpread({}, form.value), {}, {
        custProvinceName: '',
        custProvinceCode: '',
        custCityName: '',
        custCityCode: '',
        custDistrictName: '',
        custDistrictCode: ''
      });

      while (parent) {
        let areaLevel = parent.areaLevel.replace(/^[a-z]/, i => i.toLocaleUpperCase());
        form.value['cust' + areaLevel + 'Code'] = parent.id;
        form.value['cust' + areaLevel + 'Name'] = parent.text;
        parent = parent.parent;
      }
    }

    function checkLinkMan(rule, val, cb) {
      if (val && val.length > 20) {
        cb(new Error('联系人名称长度不可超过20'));
        return;
      }

      cb();
    }

    function checkLinkPhone(rule, val, cb) {
      if (val && !/^[0-9]{11}$/.test(val)) {
        cb(new Error('联系电话格式不正确'));
        return;
      }

      cb();
    }

    function confirm(status) {
      if (status === 0) {
        var _props$custTypeList$f;

        // 驳回不需要效验表单
        emit('success', _objectSpread(_objectSpread({}, form.value), {}, {
          id: props.currentData.id,
          status,
          custTypeName: (_props$custTypeList$f = props.custTypeList.find(i => i.dictitemCode === form.value.custType)) === null || _props$custTypeList$f === void 0 ? void 0 : _props$custTypeList$f.dictitemName
        }));
      } else {
        formRef.value.validate((result, error) => {
          if (!error) {
            var _props$custTypeList$f2;

            emit('success', _objectSpread(_objectSpread({}, form.value), {}, {
              id: props.currentData.id,
              status,
              custTypeName: (_props$custTypeList$f2 = props.custTypeList.find(i => i.dictitemCode === form.value.custType)) === null || _props$custTypeList$f2 === void 0 ? void 0 : _props$custTypeList$f2.dictitemName
            }));
          }
        });
      }
    } // 相似客户列表


    const table = ref([]);

    function getList() {
      return getApplySimilarCust({
        custName: form.value.custName
      }).then(res => {
        table.value = get(res, 'data', []).map(item => {
          item.checked = false;
          return item;
        });
      });
    }

    function matchApplyCust() {
      // console.log(props.currentData)
      let selectedData = table.value.find(v => v.checked);

      if (!selectedData) {
        ElMessage.warning('请选择匹配客户');
        return;
      }

      let body = {
        appliyId: props.currentData.id,
        custName: props.currentData.custName,
        matchCustName: selectedData.custName
      };
      matchApplySimilarCust(body).then(res => {
        if (res.success) {
          ElMessage.success('匹配成功，该条申请记录已自动驳回');
          emit('refresh');
          return;
        }

        ElMessage.error('匹配失败');
      });
    }

    function tableCheckHandle(row) {
      if (row.checked) {
        let list = table.value.map(item => {
          if (item.erpCustId === row.erpCustId) return item;
          item.checked = false;
          return item;
        });
        table.value = list;
      }
    } // 地址匹配


    const addressLoading = ref(false);
    const municipality = ['北京市', '天津市', '上海市', '重庆市'];
    const elTreeData = ref([]);

    function addressRecognitionHandle() {
      addressLoading.value = true;
      let body = {
        text: form.value.address
      };
      addressRecognition(body).then(res => {
        let {
          success,
          data
        } = res;
        if (!success) return;
        let targetObj = props.areaTreeData.find(item => item.text == data.province);

        if (data.city) {
          if (municipality.find(v => v === data.city) == undefined) {
            targetObj = targetObj.children.find(item => item.text == data.city);
          }

          if (data.county) {
            targetObj = targetObj.children.find(item => item.text == data.county);
          }
        }

        form.value.custAddressCode = targetObj.id;
        changeArea(targetObj);
      }).finally(() => addressLoading.value = false);
    }

    function elTreeSelectFocus(e) {
      if (e === true) {
        elTreeData.value = [];
        setTimeout(() => elTreeData.value = props.areaTreeData, 0);
      }
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_tree_select = _resolveComponent("el-tree-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "审核普查申请记录",
        width: "1100px",
        "custom-class": "survey-apply-modal",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[6] || (_cache[6] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: _cache[7] || (_cache[7] = $event => confirm(0))
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = $event => confirm(1))
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "90px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, {
            prop: "custName",
            label: "客户名称:",
            rules: [{
              required: true,
              message: '客户名称不可为空'
            }, {
              max: 50,
              message: '客户名称长度不可超过50'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.custName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.custName = $event),
              placeholder: "请输入客户名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table, {
            data: table.value
          }, {
            default: _withCtx(() => [_createVNode(_component_el_table_column, {
              label: "选择",
              width: "55"
            }, {
              default: _withCtx(scope => [_createVNode(_component_el_checkbox, {
                modelValue: scope.row.checked,
                "onUpdate:modelValue": $event => scope.row.checked = $event,
                onChange: $event => tableCheckHandle(scope.row)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "60"
            }), _createVNode(_component_el_table_column, {
              property: "custName",
              label: "客户名称"
            }), _createVNode(_component_el_table_column, {
              property: "custTypeName",
              label: "客户类型",
              width: "120"
            }), _createVNode(_component_el_table_column, {
              label: "客户区域"
            }, {
              default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.provinceName), 1), _createElementVNode("span", null, "-" + _toDisplayString(scope.row.cityName), 1), _createElementVNode("span", null, "-" + _toDisplayString(scope.row.areaName), 1)]),
              _: 1
            }), _createVNode(_component_el_table_column, {
              property: "address",
              label: "客户地址"
            })]),
            _: 1
          }, 8, ["data"]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: matchApplyCust
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          })])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "custType",
                label: "客户类型:",
                rules: {
                  required: true,
                  message: '客户类型不可为空'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.custType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.custType = $event)
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.custTypeList, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      label: item.dictitemName,
                      value: item.dictitemCode,
                      key: item.dictitemCode
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "custAddressCode",
                label: "客户区域:",
                rules: {
                  required: true,
                  message: '客户区域不可为空'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_tree_select, {
                  modelValue: form.value.custAddressCode,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.custAddressCode = $event),
                  data: __props.areaTreeData,
                  label: "text",
                  "node-key": "id",
                  onNodeClick: changeArea,
                  props: {
                    label: 'text'
                  },
                  "check-strictly": true,
                  filterable: "",
                  accordion: ""
                }, null, 8, ["modelValue", "data"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "address",
            label: "客户地址:",
            rules: [{
              required: true,
              message: '客户地址不可为空'
            }, {
              max: 100,
              message: '客户地址长度不可超过100'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.address,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.address = $event),
              placeholder: "请输入客户地址",
              onBlur: addressRecognitionHandle
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 10
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "linkMan",
                label: "联系人:",
                rules: {
                  validator: checkLinkMan,
                  trigger: 'blur'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.linkMan,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.linkMan = $event),
                  placeholder: "请输入联系人"
                }, null, 8, ["modelValue"])]),
                _: 1
              }, 8, ["rules"])]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                prop: "linkPhone",
                label: "联系电话:",
                rules: {
                  validator: checkLinkPhone,
                  trigger: 'blur'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.linkPhone,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.linkPhone = $event),
                  placeholder: "请输入联系电话"
                }, null, 8, ["modelValue"])]),
                _: 1
              }, 8, ["rules"])]),
              _: 1
            }), __props.currentData.licenseUrl ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createVNode(_component_el_image, {
                src: __props.currentData.licenseUrl,
                style: {
                  "width": "100px",
                  "height": "100px"
                },
                "preview-src-list": [__props.currentData.licenseUrl]
              }, null, 8, ["src", "preview-src-list"])])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })])), [[_directive_loading, addressLoading.value]])]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};